(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /**
   * Filter/Sortierung ohne Neuladen: liest das geänderte Formular, lädt die Section über die
   * Section-Rendering-API (PullEnergy.fetchSection), ersetzt [data-facets-swap]-Bereiche und
   * schreibt die URL in die History. Offene Filtergruppen und Fokus bleiben erhalten.
   */
  class FacetFilters extends HTMLElement {
    #request = 0;
    #timer = 0;

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', this.#onChange);
      this.addEventListener('input', this.#onInput);
      this.addEventListener('submit', this.#onSubmit);
      this.addEventListener('click', this.#onClick);
      window.addEventListener('popstate', this.#onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.#onPopState);
      clearTimeout(this.#timer);
    }

    /** URL aus einem Formular; Filterformulare übernehmen die aktuelle Sortierung aus der Toolbar. */
    #urlFrom(form) {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form)) {
        if (typeof value === 'string' && value.trim() !== '') params.append(key, value.trim());
      }
      if (!form.hasAttribute('data-facets-sort')) {
        const sort = this.querySelector('[data-facets-sort] select');
        if (sort?.value) params.set('sort_by', sort.value);
      }
      params.delete('page');
      const query = params.toString();
      return `${window.location.pathname}${query ? `?${query}` : ''}`;
    }

    #onChange = (event) => {
      const form = event.target.closest('[data-facets-form]');
      if (!form) return;
      clearTimeout(this.#timer);
      this.render(this.#urlFrom(form));
    };

    #onInput = (event) => {
      if (!event.target.matches('[data-price-input]')) return;
      const form = event.target.closest('[data-facets-form]');
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => this.render(this.#urlFrom(form)), 700);
    };

    #onSubmit = (event) => {
      const form = event.target.closest('[data-facets-form]');
      if (!form) return;
      event.preventDefault();
      clearTimeout(this.#timer);
      this.render(this.#urlFrom(form));
      if (event.submitter?.hasAttribute('data-facets-done')) this.querySelector('drawer-dialog')?.close();
    };

    #onClick = (event) => {
      const link = event.target.closest('[data-facets-link]');
      if (!link) return;
      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      this.render(url.pathname + url.search);
    };

    #onPopState = () => {
      this.render(window.location.pathname + window.location.search, false);
    };

    /**
     * Lädt die Section für eine URL und tauscht die Bereiche aus.
     * @param {string} url
     * @param {boolean} [push]
     */
    async render(url, push = true) {
      const fetchSection = window.PullEnergy?.fetchSection;
      if (!fetchSection) {
        window.location.assign(url);
        return;
      }
      const request = ++this.#request;
      this.setAttribute('aria-busy', 'true');
      try {
        const doc = await fetchSection(this.sectionId, url);
        if (request !== this.#request) return;
        const focusId = document.activeElement?.id;
        const openGroups = this.#openGroups();
        for (const current of this.querySelectorAll('[data-facets-swap]')) {
          const fresh = doc.querySelector(`[data-facets-swap="${current.dataset.facetsSwap}"]`);
          if (fresh) current.replaceWith(fresh);
        }
        this.#restoreGroups(openGroups);
        if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
        if (push) window.history.pushState({ facets: true }, '', url);
      } catch (error) {
        console.error(error);
        window.location.assign(url);
      } finally {
        if (request === this.#request) this.removeAttribute('aria-busy');
      }
    }

    /** Merkt sich, welche Filtergruppen der Kunde auf- oder zugeklappt hat (je Formular). */
    #openGroups() {
      const state = new Map();
      for (const group of this.querySelectorAll('[data-facet-group]')) {
        const form = group.closest('form')?.id ?? '';
        state.set(`${form}|${group.dataset.facetGroup}`, group.open);
      }
      return state;
    }

    #restoreGroups(state) {
      for (const group of this.querySelectorAll('[data-facet-group]')) {
        const key = `${group.closest('form')?.id ?? ''}|${group.dataset.facetGroup}`;
        if (state.has(key)) group.open = state.get(key);
      }
    }
  }

  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    // Offenes Sprach-/Länder-Dropdown bei Klick daneben oder Escape schließen
  document.addEventListener('click', (event) => {
    for (const details of document.querySelectorAll('.lang-switch__details[open]')) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    }
  });
  // Land/Währung: Auswahl sofort übernehmen
  document.addEventListener('change', (event) => {
    if (event.target.matches?.('[data-localization-autosubmit]')) event.target.form?.submit();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const details of document.querySelectorAll('.lang-switch__details[open]')) {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    /**
   * Vorschläge beim Tippen: entprellt, bricht alte Anfragen ab, Combobox-Tastatursteuerung
   * (Pfeile, Enter, Esc). Ergebnis-HTML kommt aus sections/predictive-search.liquid.
   */
  class PredictiveSearch extends HTMLElement {
    #controller = null;
    #timer = 0;
    #index = -1;

    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.reset = this.querySelector('[data-predictive-reset]');
      if (!this.input || !this.panel) return;
      this.input.addEventListener('input', this.#onInput);
      this.input.addEventListener('keydown', this.#onKeydown);
      this.input.addEventListener('focus', this.#onFocus);
      this.reset?.addEventListener('click', this.#onReset);
      this.addEventListener('focusout', this.#onFocusOut);
      document.addEventListener('pointerdown', this.#onOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.#onOutside);
      this.#controller?.abort();
      clearTimeout(this.#timer);
    }

    #onInput = () => {
      const query = this.input.value.trim();
      if (this.reset) this.reset.hidden = query === '';
      clearTimeout(this.#timer);
      if (query.length < 2) {
        this.#close();
        return;
      }
      this.#timer = setTimeout(() => this.#search(query), 220);
    };

    #onFocus = () => {
      if (this.input.value.trim().length >= 2 && this.panel.innerHTML.trim() !== '') this.#open();
    };

    #onReset = (event) => {
      // type="reset" stellt sonst den vorbelegten Begriff wieder her
      event.preventDefault();
      this.input.value = '';
      this.reset.hidden = true;
      this.#close();
      requestAnimationFrame(() => this.input.focus());
    };

    #onFocusOut = (event) => {
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.#close();
      }, 0);
    };

    #onOutside = (event) => {
      if (!this.contains(event.target)) this.#close();
    };

    async #search(query) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'query,product,collection,page,article');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][prefix]', 'last');
      // Standard ohne Tags: Kartennummer ohne führende Null („71“ für 071) steht nur im Tag „Nummer: 71“
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');
      url.searchParams.set('section_id', 'predictive-search');
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.#controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-predictive-content]');
        if (!content) return;
        // IDs eindeutig machen (mehrere Suchfelder auf einer Seite möglich)
        for (const el of content.querySelectorAll('[id]')) el.id = `${this.dataset.prefix}-${el.id}`;
        for (const el of content.querySelectorAll('[aria-labelledby]')) el.setAttribute('aria-labelledby', `${this.dataset.prefix}-${el.getAttribute('aria-labelledby')}`);
        this.panel.replaceChildren(content);
        this.#index = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.#open();
        this.#announce(content.dataset.predictiveStatus ?? '');
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    #open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    #close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.#index = -1;
    }

    get #options() {
      return Array.from(this.panel.querySelectorAll('[role="option"]'));
    }

    #onKeydown = (event) => {
      if (event.key === 'Escape') {
        if (!this.panel.hidden) {
          event.preventDefault();
          this.#close();
        }
        return;
      }
      if (this.panel.hidden) return;
      const options = this.#options;
      if (!options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.#index = (this.#index + step + options.length) % options.length;
        for (const [i, option] of options.entries()) option.setAttribute('aria-selected', String(i === this.#index));
        const active = options[this.#index];
        this.input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
        return;
      }
      if (event.key === 'Enter' && this.#index >= 0) {
        event.preventDefault();
        options[this.#index].querySelector('a')?.click();
      }
    };

    #announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Galerie: Einrasten, Punkte/Thumbnails/Pfeile, Sprung zum Variantenbild, Lightbox mit Klick-Zoom.
   */
  class ProductGallery extends HTMLElement {
    #observer = null;
    #active = 0;

    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.lightbox = this.querySelector('[data-lightbox]');
      this.addEventListener('click', this.#onClick);
      this.lightbox?.addEventListener('click', this.#onLightboxClick);

      if (this.slides.length > 1 && 'IntersectionObserver' in window) {
        this.#observer = new IntersectionObserver(this.#onIntersect, { root: this.track, threshold: 0.6 });
        for (const slide of this.slides) this.#observer.observe(slide);
      }
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.removeEventListener('click', this.#onClick);
    }

    get #smooth() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    /** @param {number} index @param {ScrollBehavior} [behavior] */
    goTo(index, behavior = this.#smooth) {
      if (!this.slides.length) return;
      const target = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior });
      this.#setActive(target);
    }

    /**
     * Springt zum Bild einer Medien-ID (Variantenbild); andere Medien bleiben in der Galerie.
     * Außer Sicht (z. B. mobil weiter unten bei den Varianten) ohne Animation.
     * @param {number|string} mediaId
     * @returns {boolean} Bild gefunden
     */
    showMedia(mediaId) {
      if (!mediaId) return false;
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index < 0) return false;
      if (index === this.#active) return true;
      const rect = this.track.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < window.innerHeight;
      this.goTo(index, visible ? this.#smooth : 'auto');
      return true;
    }

    #onIntersect = (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.#setActive(this.slides.indexOf(entry.target));
      }
    };

    #setActive(index) {
      if (index < 0) return;
      this.#active = index;
      for (const button of this.querySelectorAll('[data-gallery-go]')) {
        const current = Number(button.dataset.galleryGo) === index;
        if (current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      }
    }

    #onClick = (event) => {
      const go = event.target.closest('[data-gallery-go]');
      if (go) {
        this.goTo(Number(go.dataset.galleryGo));
        return;
      }
      const step = event.target.closest('[data-gallery-step]');
      if (step) {
        this.goTo(this.#active + Number(step.dataset.galleryStep));
        return;
      }
      const zoom = event.target.closest('[data-zoom]');
      if (zoom && this.lightbox) {
        event.preventDefault();
        this.#openLightbox(Number(zoom.dataset.zoom));
      }
    };

    #openLightbox(index) {
      this.lightbox.showModal();
      document.body.classList.add('has-drawer');
      this.lightbox.addEventListener('close', () => document.body.classList.remove('has-drawer'), { once: true });
      const items = this.lightbox.querySelectorAll('[data-lightbox-item]');
      items[index]?.scrollIntoView({ block: 'start' });
      this.lightbox.querySelector('[data-lightbox-close]')?.focus();
    }

    #onLightboxClick = (event) => {
      if (event.target === this.lightbox || event.target.closest('[data-lightbox-close]')) {
        this.lightbox.close();
        return;
      }
      const toggle = event.target.closest('[data-lightbox-toggle]');
      if (!toggle) return;
      const zoomed = toggle.getAttribute('aria-pressed') === 'true';
      const rect = toggle.getBoundingClientRect();
      const x = event.clientX ? ((event.clientX - rect.left) / rect.width) * 100 : 50;
      const y = event.clientY ? ((event.clientY - rect.top) / rect.height) * 100 : 50;
      toggle.style.setProperty('--zx', `${x.toFixed(1)}%`);
      toggle.style.setProperty('--zy', `${y.toFixed(1)}%`);
      toggle.setAttribute('aria-pressed', zoomed ? 'false' : 'true');
    };
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

})();
